<template>
  <component :is="fdocumentData === undefined ? 'div' : 'b-card'">
    <!-- Alert: No Fdocument found -->
    <b-alert variant="danger" :show="fdocumentData === undefined">
      <h4 class="alert-heading">Erreur lors de chargement du contenu</h4>
      <div class="alert-body">
        Aucun element trouvé avec cet identifiant. Vérifier
        <b-link class="alert-link" :to="{ name: 'fdocument-list' }">
          Liste des elements
        </b-link>
        pour les autres element.
      </div>
    </b-alert>

    <data-add-tab
      :fdocument-data="fdocumentData"
      :defaultfdocument-data="defaultfdocumentData"
      class="mt-2"
    />
  </component>
</template>

<script>
import {
  BTab,
  BTabs,
  BCard,
  BRow,
  BCol,
  BAlert,
  BLink,
  BFormCheckbox,
  BButton,
} from "bootstrap-vue";
import { ref, onUnmounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import storeModule from "./storeModule";
import DataAddTab from "./FormData.vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BRow,
    BCol,
    BAlert,
    BLink,
    BFormCheckbox,
    DataAddTab,
    BButton,
    // DataAddTabInformation,
    // DataAddTabSocial,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      operationTitle: "",
      operationIcon: "",
    };
  },
  mounted() {
    if (router.currentRoute.name == "fdocument-add-new") {
      this.operationTitle = "Ajouter Fdocument";
      this.operationIcon = "AddIcon";
    }
    if (router.currentRoute.name == "fdocument-view") {
      this.operationTitle = "Détails de l'Fdocument";
      this.operationIcon = "EyeIcon";
    }
    if (router.currentRoute.name == "fdocument-edit") {
      this.operationTitle = "Modification de l'Fdocument";
      this.operationIcon = "EditIcon";
    }
  },
  methods: {
    prevPage() {
      router.push({ name: "fdocument-list" });
    },
    convertBoolToInt(value) {
      if (value == 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  setup() {
    let fdocumentData = ref(null);
    let APP_STORE_MODULE_NAME = "app-fdocument";

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME))
      store.registerModule(APP_STORE_MODULE_NAME, storeModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME))
        store.unregisterModule(APP_STORE_MODULE_NAME);
    });

    var defaultfdocumentData = ref({
      bank: "",
      cheque: "",
      amount: "",
      currency: "", 
      beneficiary_ref: "", 
      date: "", 
      notes: "", 
    }); 

    if (router.currentRoute.name == "fdocument-add-new") {
      // init empty fdocument data
      fdocumentData = defaultfdocumentData;
    } else {
      // requirement //
      store
        .dispatch(APP_STORE_MODULE_NAME + "/fetchModule", {
          id: router.currentRoute.params.id,
        })
        .then((response) => {
          fdocumentData.value = response.data;
        })
        .catch((error) => {
          console.log(error);
          fdocumentData.value = undefined;
        });
    }

    return {
      fdocumentData,
      defaultfdocumentData,
    };
  },
};
</script>
